import { useState } from 'react';
import { Footer } from './components/sections/Footer';
import { Header } from './components/sections/Header';
import { Pricing } from './components/sections/Pricing';
import { Comparison } from './components/sections/Comparison';
import { Showcase } from './components/sections/Showcase';
import { Steps } from './components/sections/Steps';
import { Marquee } from './components/ui/Marquee';
import { ScrollTop } from './components/ui/ScrollTop';
import { useLanguage } from './i18n/useLanguage';
import './styles/app.scss';

export const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="page-container">
      <Header
        isMenuOpen={isMenuOpen}
        language={language}
        onLanguageChange={setLanguage}
        onMenuToggle={() => setIsMenuOpen((current) => !current)}
        onNavigate={() => setIsMenuOpen(false)}
        t={t}
      />

      <main>
        <Pricing t={t} />
        <Steps t={t} />
        <Marquee text={t('marquee')} />
        <Comparison t={t} />
        <Showcase t={t} />
      </main>

      <Footer t={t} />
      <ScrollTop label={t('footer.top')} />
    </div>
  );
};
